import React, { useState, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import apiService from '../Common/Configurations/APIService';
import config from '../Common/Configurations/APIConfig';
import WebsiteRenderer from '../template-library/WebsiteRenderer';
import '../template-library/global-styles.css'; // Don't forget to import your global override styles
import { useAuth } from '../Common/Configurations/AuthContext';

// --- THIS HELPER FUNCTION IS THE KEY ---
// It converts the StyleJson from the DB into CSS variables for the browser.
const generateCssVariables = (config) => {
    if (!config) return {};
    const variables = {
        '--font-main': config.body?.fontFamily || "'Inter', sans-serif",
        '--primary': config.primary,
        '--secondary': config.secondary,
        '--topbar-bg-color': config.topBar?.bgColor,
        '--topbar-text-color': config.topBar?.textColor,
        '--header-bg-color': config.header?.bgColor,
        '--header-text-color': config.header?.textColor,
        '--hero-overlay-color': config.hero?.overlayColor,
        '--hero-subtitle-color': config.hero?.subtitleColor,
        '--body-bg': config.body?.bgColor,
        '--body-text': config.body?.textColor,
        '--footer-bg-color': config.footer?.bgColor,
        '--footer-text-color': config.footer?.textColor,
        '--footer-link-color': config.footer?.linkColor
    };
    return variables;
};


function WebsiteTemplatePreviewPage() {
    const [currentView, setCurrentView] = useState('home');
   const { templateId, viewName, packageId } = useParams(); 
    const [layout, setLayout] = useState(null);
    const [styleConfig, setStyleConfig] = useState(null); // <-- NEW: State for the style object
     const [destinations, setDestinations] = useState([]);
       const [heroData, setHeroData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [headerMenu, setHeaderMenu] = useState([]); // 👈 NEW: State for header menu
     const [footerData, setFooterData] = useState(null);
      const [aboutData, setAboutData] = useState(null);
         const [contactData, setContactData] = useState(null);
     const { user } = useAuth(); 
     const previewBranding = {
        phone: user?.companyPhone || "+91 0000000000",
        email: user?.companyEmail || "contact@trawtel.com",
        logoUrl: user?.companyLogo || "https://via.placeholder.com/150x50?text=Company+Logo",
        companyName: user?.companyName || "Trawtel"
    };
    
    useEffect(() => {
        if (!templateId) return;

        const fetchPreviewData = async () => {
            try {
                // Call the updated backend endpoint
                const data = await apiService.getById(config.GETTEMPLATEPREVIEWDATA, templateId);

                console.log('Fetched template preview data:', data);

                if (!data || !data.layoutJson || !data.styleJson) {
                    throw new Error("API response is missing required data.");
                }

                // We no longer need to inject a <link> tag for a static CSS file.
                
                // Save the parsed JSON data to state
                setLayout(JSON.parse(data.layoutJson));
                setStyleConfig(JSON.parse(data.styleJson));
                 if(data.defaultDestinationsJson) {
                    const parsed = JSON.parse(data.defaultDestinationsJson);
                    setDestinations(parsed.destinations || parsed || []); 
                }

                // 👇 NEW: Parse Hero Data
                if(data.defaultHeroJson) {
                    setHeroData(JSON.parse(data.defaultHeroJson)); 
                } 
                if(data.defaultHeaderJson) {
    setHeaderMenu(JSON.parse(data.defaultHeaderJson)); 
}
if(data.defaultFooterJson) {
    setFooterData(JSON.parse(data.defaultFooterJson)); 
}
if(data.defaultAboutJson) {
                    setAboutData(JSON.parse(data.defaultAboutJson)); 
                } 
                 if(data.defaultContactJson) {
                    setContactData(JSON.parse(data.defaultContactJson)); 
                } 



            
                
            } catch (err) {
                setError(err.message || 'Failed to load template preview.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchPreviewData();
    }, [templateId]);
   const getActiveViewState = () => {
        if (packageId) {
            return { name: 'package-details', params: { packageId } };
        }
        // If viewName exists (e.g. 'destinations'), use it. Otherwise default to 'home'
        return { name: viewName || 'home', params: null };
    };
    // This converts the styleConfig state into a style object with CSS variables.
    const cssVariables = useMemo(() => {
        return styleConfig ? generateCssVariables(styleConfig) : {};
    }, [styleConfig]);

    if (loading) return <div><h4>Loading Preview...</h4></div>;
    if (error) return <div><h1>{error}</h1></div>;
    if (!layout) return null;

    return (
        // Apply the CSS variables to a wrapper div.
        // All components inside will now inherit these styles.
          <div style={cssVariables} className="template-wrapper">
            <WebsiteRenderer 
                layout={layout} 
                destinations={destinations} // 👈 Pass the fetched default destinations
                 heroData={heroData}
                 branding={previewBranding}
                 headerMenu={headerMenu}
                 footerData={footerData}
                  aboutData={aboutData}
                
    contactData={contactData}
                mode="preview" 
                 templateId={templateId} // 👈 PASS THE ID EXTRACTED FROM useParams()
          viewState={getActiveViewState()} 
            />
            
        </div>
    );
}

export default WebsiteTemplatePreviewPage;